import script from "./sf-assistant-checks-unread-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-assistant-checks-unread-panel.vue?vue&type=script&setup=true&lang=ts"

import "./sf-assistant-checks-unread-panel.vue?vue&type=style&index=0&id=40759c37&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40759c37"]])

export default __exports__